import IMask from 'imask'

document.addEventListener('DOMContentLoaded', () => {
  const telInput = document.querySelector('.form-field__tel')
  const maskOptions = {
    mask: '+{7} (000) 000 - 00 - 00',
  }

  if (telInput) IMask(telInput, maskOptions)
})
